import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import _ from 'lodash';
import { headerActions, leadAcceptanceActions, referralActions } from 'actions';
import { bindActionCreators } from 'redux';
import { HEADER, APPOINTMENT_STATUS } from '_constants';

import ContentLoader from '../common/loaders/ContentLoader';
import LeadAcceptanceBody from './LeadAcceptanceBody';

const headerSettings = {
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Congrats you have a new lead!',
  hasBackButton: true,
  noIcons: true
};

class LeadAcceptance extends React.Component {
  static propTypes = {
    setHeader: PropTypes.func.isRequired,
    leadAcceptance: PropTypes.object.isRequired,
    appointment: PropTypes.object.isRequired,
    acceptAppointment: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    userprofile: PropTypes.object.isRequired,
    activeReferral: PropTypes.object.isRequired,
    activeAppointment: PropTypes.object.isRequired,
    initReferral: PropTypes.func.isRequired
  };

  componentDidMount = async () => {
    this.props.setHeader(headerSettings);
    const { contactId, opportunityId, appointmentId } = this.props.match.params;
    await this.props.initReferral(contactId, this.props.userprofile.memberKey, appointmentId);
    const { activeReferral, activeAppointment } = this.props;
    if (!_.isEmpty(activeReferral)) {
      if (!(activeAppointment && activeAppointment.eventStatus && activeAppointment.eventStatus.id === APPOINTMENT_STATUS.TENTATIVE.id)) {
        this.props.history.replace(`/referraldetails/${contactId}/`);
      }
    }
    await this.props.fetch(contactId, opportunityId, appointmentId, false);
  }

  onAcceptLead = async () => {
    const { params } = this.props.match;
    const { opportunityId } = params;
    const { appointment } = this.props;
    const updApptOppIds = [...appointment.opportunityKeys, opportunityId].map(cao => +cao);
    const currentAppointment = {
      ...appointment,
      opportunityKeys: updApptOppIds.filter((oId, ix) => updApptOppIds.indexOf(oId) === ix),
      contactIDs: [{ id: appointment.contactKeys[0] }],
      id: appointment.calendarEventKey
    };

    await this.props.acceptAppointment(currentAppointment);
    this.props.history.replace(`/referraldetails/${this.props.match.params.contactId}/`);
  }

  render () {
    if (_.isEmpty(this.props.leadAcceptance)) {
      return <ContentLoader isLoading />;
    }
    return (
      <React.Fragment>
        <div className='lead-notification-container'>
          <LeadAcceptanceBody
            leadAcceptance={this.props.leadAcceptance}
            onClickHandler={this.onAcceptLead}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { leadAcceptance, userprofile, referrals } = state;
  return {
    leadAcceptance,
    appointment: _.get(leadAcceptance, 'appointment', {}),
    userprofile: userprofile || {},
    activeReferral: referrals.activeReferral || {},
    activeAppointment: referrals.activeAppointment || {}
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  fetch: bindActionCreators(leadAcceptanceActions.fetch, dispatch),
  acceptAppointment: bindActionCreators(leadAcceptanceActions.acceptAppointment, dispatch),
  initReferral: bindActionCreators(referralActions.initReferral, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LeadAcceptance));
